import { IEventData } from 'meta/pages/v4/event'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  idsOrCodeUrls: string[]
}

type Response = { items: IEventData[] }

export const getBulkData = async (props: Props): Promise<Response> => {
  const { idsOrCodeUrls } = props

  const endpoint = ApiEndpoint.v4.event.bulk(idsOrCodeUrls)

  const { data } = await HttpRequestForApiV4.get<Response>(endpoint)
  return data
}
